<template>
    <div class="loading"></div>
</template>

<script>
export default {
  name: 'waiting', // 定义的组件名称 使用时写法：loading
};
</script>

<style scoped>
    .loading {
        position: fixed;
        left: 40px;
        right: 40px;
        bottom: 0;
        background: url('../../../../static/login/waiting.svg') center center no-repeat #fff;
        width: 100vw;
        height: 70vh;
        z-index: 1000;
    }
</style>



// WEBPACK FOOTER //
// src/components/common/loading/waiting.vue